export default "__VITE_ASSET__Cd9BREJO__"